<template>
  <div
    class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
    id="popup-content"
    @click.self="close"
  >
    <div
      class="relative w-full lg:w-[83%] max-h-screen bg-[#f8f8f8] p-[40px] overflow-auto"
    >
      <button
        class="absolute right-12 top-12 cursor-pointer z-10"
        type="button"
        @click="close"
      >
        <span class="mdi text-xl mdi-close"></span>
      </button>
      <div
        class="w-full pb-2 flex flex-col justify-start items-start gap-[15px]"
      >
        <h2 class="text-[##353535] text-[20px] leading-[28px] font-semibold">
          Viewing Order Report : Volume By Category Report
        </h2>
        <div
          class="flex xs:flex-col md:flex-row xs:justify-start md:justify-between w-full xs:items-start xs:gap-4 lg-gap-2 md:items-center"
        >
          <p class="text-[#353535] text-[14px] leading-[20px] font-medium">
            Volume by category report
            <span
              v-if="
                this.filter.dateStart == '' || this.filter.dateStart == null
              "
            >
              <span> <strong>as at</strong> {{ this.filter.dateEnd }}</span>
            </span>
            <span
              v-if="
                this.filter.dateStart != '' &&
                  this.filter.dateStart != null &&
                  this.filter.dateEnd != '' &&
                  this.filter.dateEnd != null
              "
            >
              <span
                v-if="
                  this.filter.dateStart != '' && this.filter.dateStart != null
                "
                ><span
                  ><strong>from</strong> {{ this.filter.dateStart }}
                </span></span
              >
              <span><strong>to</strong> {{ this.filter.dateEnd }}</span>
            </span>
          </p>
          <div
            class="flex gap-1 sm:gap-3 flex-wrap xs:justify-start lg:justify-center xs:items-start lg:items-center"
          >
            <button
              @click="viewFilter"
              class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
            >
              <span class="">
                <img src="/assets/icon/sort.svg" alt="" />
              </span>
              Filters
            </button>
            <button
              @click="csvExport(csvDataAll)"
              class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
            >
              <span class="">
                <img src="/assets/icon/export.svg" alt="" />
              </span>
              Export Data
            </button>
          </div>
        </div>
        <div class="table-responsive">
          <table
            class="table m-0 p-0 dataTable text-nowrap dataex-html5-selectors"
          >
            <thead class="bg-white">
              <tr>
                <th>Category Name</th>
                <th>
                  Quantity Sold
                </th>
                <th>
                  Value Of Orders (₦)
                </th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr v-for="item in ReportItems" :key="item.categoryId">
                <td>{{ item.categoryName }}</td>
                <td>
                  {{ formatNumber(item.quantitySold) }}
                </td>
                <td>
                  {{ formatMoney(item.valueOfOrders) }}
                </td>
              </tr>
              <tr v-if="!ReportItems.length">
                <td colspan="12">
                  <div class="text-center">No matching records</div>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination
            :limit="pageSize"
            :count="pageCount"
            :page="page"
            :itemsCount="count"
            @changePage="gotoPage"
            @changeLimit="changeLimit"
          />
        </div>
      </div>
    </div>
    <div
      class="modal fade colored-header colored-header-primary"
      id="mod-filter"
      role="dialog"
    >
      <ReportFilterModal
        @onsearch="page = 0"
        v-model="filter"
        extraDataType="TEXT"
        extraDataPlaceholder="Filter by category name..."
        :searchFn="getVolumeByProductCategoryReport"
      ></ReportFilterModal>
    </div>
  </div>
</template>
<script>
/* eslint-disable */

import moment from "moment";
import { helper } from "@/helper";
import Select2 from "@/components/Select2";
import JsonCSV from "vue-json-csv";
import ReportFilterModal from "@/components/Common/ReportFilterModal";
import { exportExcel } from "@/excel";
import Pagination from "../Pagination.vue";

export default {
  props: ["close"],
  name: "volumeByProductCategoryReport",
  components: {
    Select2,
    JsonCSV,
    ReportFilterModal,
    Pagination,
  },
  created() {
    this.getVolumeByProductCategoryReport();
    this.getVolumeByProductCategoryReportExportItemsAll();
  },
  data() {
    return {
      filter: {
        qry: "",
        dateStart: moment()
          .subtract(1, "years")
          .format("YYYY-MM-DD"),
        dateEnd: moment().format("YYYY-MM-DD"),
      },
      isBusy: false,
      isBusyModal: false,
      ReportItems: [],
      ExportReportItemsAll: [],
      count: 0,
      page: 0,
      pageSize: 10,
      pageCount: 10,
      pageSizeExport: 999999999,
      hasNext: false,
      hasPrev: false,
      maxPage: 0,
      pageArray: [],
      options: {
        format: "YYYY-MM-DD",
        icons: {
          time: "mdi mdi-time",
          date: "mdi mdi-calendar",
          up: "mdi mdi-chevron-up",
          down: "mdi mdi-chevron-down",
          previous: "mdi mdi-chevron-left",
          next: "mdi mdi-chevron-right",
          today: "mdi mdi-screenshot",
          clear: "mdi mdi-trash",
          close: "mdi mdi-remove",
        },
      },
      local: {
        dow: 0, // Sunday is the first day of the week
        hourTip: "Select Hour", // tip of select hour
        minuteTip: "Select Minute", // tip of select minute
        secondTip: "Select Second", // tip of select second
        yearSuffix: "", // suffix of head year
        monthsHead: "January_February_March_April_May_June_July_August_September_October_November_December".split(
          "_"
        ), // months of head
        months: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), // months of panel
        weeks: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), // weeks
        cancelTip: "cancel",
        submitTip: "confirm",
      },
    };
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
    csvData() {
      return this.exportItems.map((item) => ({
        ...item,
      }));
    },
    exportItems() {
      return this.ReportItems.map(function(item) {
        return {
          "Category Name": item.categoryName,
          "Quantity Sold": item.quantitySold,
          "Value Of Orders": item.valueOfOrders,
        };
      });
    },
    csvDataAll() {
      return this.exportItemsAll.map((item) => ({
        ...item,
      }));
    },
    exportItemsAll() {
      this.getVolumeByProductCategoryReportExportItemsAll();
      return this.ExportReportItemsAll.map(function(item) {
        return {
          "Category Name": item.categoryName,
          "Quantity Sold": item.quantitySold,
          "Value Of Orders": item.valueOfOrders,
        };
      });
    },
  },
  methods: {
    reset() {
      this.filter = {
        qry: "",
      };
    },
    viewExport() {},
    viewFilter() {
      $("#mod-filter").modal("show");
    },
    getVolumeByProductCategoryReport() {
      this.isBusy = true;

      this.$http
        .get(
          "/Reports/getVolumeByProductCategoryReport?page=" +
            this.page +
            "&pageSize=" +
            this.pageSize +
            (this.filter.qry != "" ? "&query=" + this.filter.qry : "") +
            (this.filter.dateStart != ""
              ? "&startDate=" +
                moment(this.filter.dateStart).format("YYYY-MM-DD 00:00:00")
              : "") +
            (this.filter.dateEnd != ""
              ? "&endDate=" +
                moment(this.filter.dateEnd).format("YYYY-MM-DD 23:59:59")
              : "") +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "")
        )
        .then(function(res) {
          this.ReportItems = res.body.data;
          this.page = res.body.page;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.pageCount = Math.ceil(this.count / this.pageSize);
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.maxPage = Math.ceil(this.count / this.pageSize);
          this.pageArray = [...Array(this.maxPage).keys()];

          $("#mod-filter").modal("hide");
          this.isBusy = false;
        })
        .catch(function() {
          $("#mod-filter").modal("hide");
          this.isBusy = false;
        });
    },
    getVolumeByProductCategoryReportExportItemsAll() {
      this.isBusy = true;

      this.$http
        .get(
          "/Reports/getVolumeByProductCategoryReport?page=" +
            this.page +
            "&pageSize=" +
            this.pageSizeExport +
            (this.filter.qry != "" ? "&query=" + this.filter.qry : "") +
            (this.filter.dateStart != ""
              ? "&startDate=" +
                moment(this.filter.dateStart).format("YYYY-MM-DD 00:00:00")
              : "") +
            (this.filter.dateEnd != ""
              ? "&endDate=" +
                moment(this.filter.dateEnd).format("YYYY-MM-DD 23:59:59")
              : "") +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "")
        )
        .then(function(res) {
          this.ExportReportItemsAll = res.body.data;

          $("#mod-filter").modal("hide");
          this.isBusy = false;
        })
        .catch(function() {
          $("#mod-filter").modal("hide");
          this.isBusy = false;
        });
    },
    formatDate(date) {
      return moment(date).format("lll");
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    formatNumber(val) {
      return helper.formatNumber(val);
    },
    prev() {
      if (this.page > 1) {
        this.page -= 1;
        this.getVolumeByProductCategoryReport();
      }
    },
    next() {
      if (this.hasNext) {
        this.page += 1;
        this.getVolumeByProductCategoryReport();
      }
    },

    gotoPage(page) {
      this.page = page;
      this.getVolumeByProductCategoryReport();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.page = 1;
      this.getVolumeByProductCategoryReport();
    },
    csvExport(arrData) {
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        Object.keys(arrData[0]).join(","),
        ...arrData.map((item) => Object.values(item).join(",")),
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "volume_by_sku_report.csv");
      link.click();
    },
    excelData(exportData) {
      const exportAble = exportData;
      const options = {
        headers: Object.keys(exportAble[0]),
      };
      const numericHeaders = ["Value Of Orders"];
      var titleName = "Volume By Category Report_";
      var titleFullname =
        this.filter.dateStart === "" || this.filter.dateStart == null
          ? titleName + "As At_" + this.filter.dateEnd
          : titleName + this.filter.dateStart + "_to_" + this.filter.dateEnd;
      const excelData = {
        title: titleFullname,
        headers: options.headers,
        data: exportAble,
      };
      const businessName = this.$store.getters.getCurrentUser.parent.name;
      const businessAddress = this.$store.getters.getCurrentUser.parent.address;
      exportExcel(excelData, businessName, businessAddress, numericHeaders);
    },
  },
};
</script>
